module.exports = __webpack_public_path__ + "img/VPC-insurance.cfcb9ed.jpg";